<template>
  <common-dialog v-bind="$attrs" v-on="$listeners" ref="commonDialogRef" title="提示">
    <div class="unit-dialog">
      <div class="contact">
        <div class="main-title"> 如您想成为理事单位成员，请下载提交申请表并与我们的工作人员取得联系，您的相关咨询我们将尽快回复</div>
        <div class="flex-start" style="margin-bottom: 12px">
          <img src="~@/assets/img/join/weixin.png" alt="">
          <span>ITGSA-BD</span>
        </div>
        <div class="flex-start">
          <img src="~@/assets/img/join/email.png" alt="">
          <span>service@itgsa.com</span>
        </div>
      </div>
      <div class="process">
        <div class="main-title"> 加入流程</div>
        <!--   前四个     -->
        <div class="process-content_top flex-nowrap">
          <div v-for="(item,index) in process.slice(0,4)" :key="index" class="flex-column relative">
            <img class="icon" :src="item.pic" alt="">
            <img class="arrow absolute" v-if="index < 3 "
                 src="~@/assets/img/service/process_arrow.png"
                 alt="">
            <span class="step color-level2 fontWeight-500">STEP 0{{ index + 1 }}</span>
            <span class="title color-level1 font-blod">{{ item.title }}</span>
            <span class="color-level2 fontWeight-500">{{ item.subTitle }}</span>
          </div>
        </div>
        <!--  下箭头   -->
        <div class="process-content_middle relative">
          <img class="arrow absolute"
               src="~@/assets/img/service/process_arrow.png"
               alt="">
        </div>
        <!--  后三个   -->
        <div class="process-content_bottom flex-nowrap">
          <div v-for="(item,index) in process.slice(4).reverse()" :key="index" class="flex-column relative">
            <img class="icon" :src="item.pic" alt="">
            <img class="arrow absolute" v-if="index !== 2"
                 src="~@/assets/img/service/process_arrow.png"
                 alt="">
            <span class="step color-level2 fontWeight-500">STEP 0{{ 7 - index }}</span>
            <span class="title color-level1 font-blod">{{ item.title }}</span>
            <span class="color-level2 fontWeight-500">{{ item.subTitle }}</span>
          </div>
        </div>
      </div>
      <a class="btn cursor fontWeight-500 color-level2" href="/移动智能终端生态联盟-理事成员申请表.docx">下载申请表</a>
    </div>
  </common-dialog>
</template>
<script>
import CommonDialog from "@/components/common/CommonDialog.vue";

export default {
  components: {
    CommonDialog
  },
  data() {
    return {
      process: [
        {title: '提交申请表', subTitle: '申请企业', pic: require('@/assets/img/join/member-process-1.png')},
        {title: '初审', subTitle: '联盟秘书处', pic: require('@/assets/img/join/member-process-2.png')},
        {title: '理事长单位会议表决', subTitle: '秘书长会议', pic: require('@/assets/img/join/member-process-3.png')},
        {title: '通知申请企业', subTitle: '联盟秘书处', pic: require('@/assets/img/join/member-process-4.png')},
        {title: '入会证书发放', subTitle: '联盟秘书处', pic: require('@/assets/img/join/member-process-5.png')},
        {
          title: '同步联盟章程与经费管理方法',
          subTitle: '联盟秘书处',
          pic: require('@/assets/img/join/member-process-6.png')
        },
        {title: '框架协议签署', subTitle: '联盟秘书处', pic: require('@/assets/img/join/member-process-7.png')},
      ]
    }
  },
  methods: {
    showDialog() {
      this.$refs.commonDialogRef.showDialog()
    },
    closeDialog() {
      this.$refs.commonDialogRef.closeDialog()
    }
  }
}
</script>


<style scoped lang="scss">

.unit-dialog {
  .main-title {
    height: 24px;
    line-height: 24px;
    font-weight: bold;
    font-size: 14px;
    color: $color-level1;
    display: flex;
    align-items: center;
    margin-bottom: 24px;

    &:before {
      content: '';
      display: inline-block;
      width: 4px;
      height: 24px;
      background: $color-main1;
      margin-right: 12px;
    }
  }

  .contact {
    margin-bottom: 32px;

    img {
      margin-right: 12px;
      width: 32px;
      height: 32px;
    }
  }

  .process {
    .icon {
      width: 40px;
      height: 40px;
    }

    .step {
      margin: 16px 0 4px;
      line-height: 24px;
      height: 24px;
    }

    .title {
      margin-bottom: 4px;
    }
    .arrow {
      width: 48px;
      height: 12px;
    }

    &-content_top {

      & > div:not(:last-child) {
        width: 168px;
      }

      .arrow {
        left: 80px;
        top: 15px;
      }

    }

    .process-content_middle {
      height: 88px;
      width: 100%;

      img {
        top: 40px;
        right: 100px;
        transform: rotate(90deg);
      }
    }

    &-content_bottom {

      & > div:not(:last-child) {
        width: 252px;
      }

      .arrow {
        left: 122px;
        top: 15px;
        transform: rotate(180deg);
      }

    }
  }

  .btn {
    display: block;
    margin: 60px auto 0;
    width: 240px;
    height: 40px;
    line-height: 40px;
    border-radius: 38px 38px 38px 38px;
    border: 1px solid #B3B3B3;
    text-align: center;
    &:hover {
      color: $color-level1;
      background: linear-gradient( 90deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
      border: 1px solid transparent;
    }
  }
}
</style>
